// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nss: CountryValidator<"ES"> = createValidator(
  "es.nss",
  68,
);

export default nss;
export const compact = nss.compact;
export const format = nss.format;
export const validate = nss.validate;
export const generate = (): string =>
  nss.generate?.() ??
  (() => {
    throw new Error(
      "Validator es.nss cannot generate values",
    );
  })();
